var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingleNeutral = function SvgSingleNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6C7.25 7.39239 7.80312 8.72774 8.78769 9.71231C9.77226 10.6969 11.1076 11.25 12.5 11.25C13.8924 11.25 15.2277 10.6969 16.2123 9.71231C17.1969 8.72774 17.75 7.39239 17.75 6C17.75 4.60761 17.1969 3.27226 16.2123 2.28769C15.2277 1.30312 13.8924 0.75 12.5 0.75C11.1076 0.75 9.77226 1.30312 8.78769 2.28769C7.80312 3.27226 7.25 4.60761 7.25 6V6Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 23.25C2.75 20.6641 3.77723 18.1842 5.60571 16.3557C7.43419 14.5272 9.91414 13.5 12.5 13.5C15.0859 13.5 17.5658 14.5272 19.3943 16.3557C21.2228 18.1842 22.25 20.6641 22.25 23.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSingleNeutral;